export interface IForm {
  buttonText?: string
  /**
   * Hide submit button, for use when triggering
   * submit outside form component
   */
  hideSubmit?: boolean
  /**
   * Set if form is processing and in loading state
   */
  onLoading?: (loading: boolean) => void

  /**
   * Success handler for succesful form submission
   */
  onSuccess: () => void
}

export enum CardProvider {
  Checkout = 'CHECKOUT',
  Evervault = 'EVERVAULT'
}

export interface AddCreditCardFunctionProps {
  token: string
  provider: CardProvider
  customName?: string
  cardNetwork?: string
  cvvToken?: string
  billingAddress?: {
    streetAddress: string
    subPremise: string
    city: string
    state: string
    stateCode: string
    postalCode: string
    country: string
    countryISO: string
  }
}

export interface CreditCardSerializationInput {
  cardHolderNameSecretID: string
  expirationDateSecretID: string
  panSecretID: string
}

export interface CreditCardFeeMessageProps {
  cardNetwork: string
  provider: CardProvider
}
